// @flow

import * as React from 'react';
import classNames from 'classnames';
import useSheet from 'app/jss';
import Icon from 'app/components/commons/Icon';

type Props = {
  classes: Object,
  iconType?: string,
  type?: string
};

function FunkyIcon({ classes, iconType, type }: Props) {
  if (iconType) {
    return <Icon type={iconType} />;
  }
  return <span className={classNames(classes.base, classes[type])} />;
}

function applyStyles() {
  return {
    base: {
      fontFamily: 'CarlaIcons',
      '-moz-osx-font-smoothing': 'grayscale',
      fontSmoothing: 'antialiased',
      lineHeight: 1
    },
    scheduled: {
      fontSize: '0.9em',
      '&:before': {
        content: '"\\64"'
      }
    },
    live: {
      '&:before': {
        content: '"\\62"'
      }
    },
    pending: {
      '&:before': {
        content: '"\\63"'
      }
    },
    tick: {
      '&:before': {
        content: '"\\61"'
      }
    }
  };
}

FunkyIcon.defaultProps = {
  iconType: undefined,
  type: 'base'
};

export default useSheet(applyStyles)(FunkyIcon);
